<template>
    <mui-footer style="padding-left: 0">
        <div class="container">
            <div class="row">
                <div class="col l6 s12">
                    <h5 class="white-text">Footer Content</h5>
                    <p class="grey-text text-lighten-4">You can use rows and columns here to organize your footer content.</p>
                </div>
                <div class="col l4 offset-l2 s12">
                    <h5 class="white-text">Links</h5>
                    <ul>
                        <li><a class="grey-text text-lighten-3" href="#!">Link 1</a></li>
                        <li><a class="grey-text text-lighten-3" href="#!">Link 2</a></li>
                        <li><a class="grey-text text-lighten-3" href="#!">Link 3</a></li>
                        <li><a class="grey-text text-lighten-3" href="#!">Link 4</a></li>
                    </ul>
                </div>
            </div>
        </div>

        <footer-copyright>
            <div class="container">
                © 2014 Copyright Text
                <a class="grey-text text-lighten-4 right" href="#!">More Links</a>
            </div>
        </footer-copyright>
    </mui-footer>
</template>

<script>
    /**
     * @example footer with copyright
     * @for footer
     * @description
     */
    module.exports = {
        components: {
            'mui-footer': require('material-ui-vue/components/footer/footer.vue'),
            'footer-copyright': require('material-ui-vue/components/footer/footer-copyright.vue')
        }
    }
</script>


/** WEBPACK FOOTER **
 ** footer-demo.vue?9c16786a
 **/